module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_9005.6b2bba11.png";